import { flow, get, size, filter, defaultTo } from 'lodash/fp';

export default (allItems, design) => flow(
  get('numberOfWindows'),
  defaultTo(flow(
    filter({ designId: design.designId }),
    size,
  )(allItems)),
)(design);
